import * as betgalaxy from './RaceDetails.styles.betgalaxy';
import * as betprofessor from './RaceDetails.styles.betprofessor';
import * as betroyale from './RaceDetails.styles.betroyale';
import * as fiestabet from './RaceDetails.styles.fiestabet';
import * as puntcity from './RaceDetails.styles.puntcity';
import * as puntgenie from './RaceDetails.styles.puntgenie';
import * as questbet from './RaceDetails.styles.questbet';
import * as sterlingparker from './RaceDetails.styles.sterlingparker';
import * as vikingbet from './RaceDetails.styles.vikingbet';
import * as volcanobet from './RaceDetails.styles.volcanobet';
import * as wellbet from './RaceDetails.styles.wellbet';
import * as juicybet from './RaceDetails.styles.juicybet';
import * as goldenrush from './RaceDetails.styles.goldenrush';
import * as forsport from './RaceDetails.styles.forsport';
import * as junglebet from './RaceDetails.styles.junglebet';
import * as sugarcastle from './RaceDetails.styles.sugarcastle';
import * as oldgill from './RaceDetails.styles.oldgill';
import * as buffalobet from './RaceDetails.styles.buffalobet';
import * as titanbet from './RaceDetails.styles.titanbet';
import * as slambet from './RaceDetails.styles.slambet';
import * as gigabet from './RaceDetails.styles.gigabet';
import * as betstride from './RaceDetails.styles.betstride';
import * as templebet from './RaceDetails.styles.templebet';
import * as goldenbet888 from './RaceDetails.styles.goldenbet888';
import * as hyperbet from './RaceDetails.styles.hyperbet';
import * as bet777 from './RaceDetails.styles.bet777';
import * as chromabet from './RaceDetails.styles.chromabet';
import * as bet575 from './RaceDetails.styles.bet575';
import * as betblast from './RaceDetails.styles.betblast';
import * as pyramidbet from './RaceDetails.styles.pyramidbet';
import * as magnumbet from './RaceDetails.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  oldgill,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
